// extracted by mini-css-extract-plugin
export default {"title":"title_d128f3fdee3a898e10fa"};